import { startApplicationModal } from "./application-modal";

$(function () {
    const inputs = {
        billNr: $('[name="personal_data[billNr]"]'),
        billDate: $('[name="personal_data[billDate]"]'),
        billPos: $('[name="personal_data[billPos]"]'),
        billNip: $('[name="personal_data[billNip]"]'),
    }

    for (const [key, input] of Object.entries(inputs)) {
        if (input.length) {
            // Przycisk „?" liczymy OD POLA, nie od .form-group: grupa jest kolumną bootstrapowego
            // .row, więc rozciąga się do wysokości najwyższej kolumny w rzędzie (etykiety bill*
            // łamią się na dwie linie), a dodatkowo rośnie o komunikat błędu z AJAX-a. Owijka
            // obejmuje sam input i jest kotwicą dla pozycjonowania (.input-hint-wrap
            // w assets/styles/sections/s-application.scss).
            input.wrap('<div class="input-hint-wrap"></div>').after(`
<button
  type="button"
  class="btn btn-input-hint-modal"
  data-bs-toggle="modal"
  data-bs-target="#modal-hint-form-application-${key}"
>
?
</button>`)
        }
    }
})

$('.application-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    // Hand off to the multi-step, uncloseable game modal instead of swapping the form
    // content. preventDefault() stops ajax-form's post-handler form.reset()/redirect.
    event.preventDefault();
    startApplicationModal(data);
});

$('[name="personal_data[billType]"]').on('change', function() {
    // Default: billPos (Numer kasy) enabled. Checking the billType control disables it; unchecking re-enables.
    $('[name="personal_data[billPos]"]', this.form.elements).closest('.form-group').prop('disabled', this.checked);
}).trigger('change');

// Preload the modal background layers (base + decor, comma-separated in data-bg-src) as soon
// as the user starts filling the bill details, so they are cached by the time the modal opens.
(function preloadModalBackground() {
    const bgSources = String($('#modal-form-application').data('bg-src') || '')
        .split(',')
        .map(src => src.trim())
        .filter(Boolean);

    if (bgSources.length === 0) {
        return;
    }

    const billFields = [
        'billType', 'billNr', 'billDate', 'billNip', 'billPos',
    ].map(name => `[name="personal_data[${name}]"]`).join(', ');

    let preloaded = false;
    $(document).on('focusin input change', billFields, function() {
        if (preloaded) {
            return;
        }
        preloaded = true;
        bgSources.forEach(src => {
            new Image().src = src;
        });
    });
})();